import { Pipe, PipeTransform } 	from '@angular/core';

@Pipe({name: 'searchFilter'})
export class SearchFilterPipe implements PipeTransform {
  	transform(value: any[], term: string, field: string): any[] {
  		if(typeof field != 'undefined' && field != '')
    		return value.filter((data:any) => data[field].toLowerCase().startsWith(term.toLowerCase()))
  	} 
}